// misc
import { getQueryParams, stringifyUrl } from '@v4/common/utils/url';
import { baseUrl } from '@v4/services/api/v3/offer';
import { fetchBadges } from '@v4/services/api/v3/car';

// mixins
import { dkModalAware } from '@v4/common/components/mixins/modal';
import { modalCarConfigurator, modalWizardCarConfigurator } from '@v4/common/components/mixins/modal-service';

// styles
import '@v4/multi-section/mixins/submodel/_index.scss';

export default () => ({
    data() {
        return {
            selectedVersion: {},
            badges: [],
            isBusy: false,
            carConfiguratorOptions: {
                gearbox: '',
                color: '',
            },
        };
    },
    components: {
        DsPollingWrapper: () => ({
            component: import(
                /* webpackChunkName: "DsPollingWrapper-vue", webpackPreload: true */ '@v4/common/components/molecules/DsPollingWrapper'
            ),
        }),
        DsPricingCard: () => ({
            component: import(
                /* webpackChunkName: "DsPricingCard-vue", webpackPreload: true */ '@v4/multi-section/components/organisms/DsPricingCard'
            ),
        }),
        SubmodelEditorialTags: () => ({
            component: import(
                /* webpackChunkName: "SubmodelEditorialTags-vue", webpackPreload: true */ '@v4/multi-section/components/organisms/SubmodelEditorialTags'
            ),
        }),
        DkRating: () => ({
            component: import(
                /* webpackChunkName: "DkRating-vue", webpackPreload: true */ '@v4/common/components/molecules/DkRating'
            ),
        }),
        ProgressBar: () => ({
            component: import(
                /* webpackChunkName: "ProgressBar-vue", webpackPreload: true */ '@v4/common/components/atoms/ProgressBar'
            ),
        }),
        ListGroup: () => ({
            component: import(
                /* webpackChunkName: "ListGroup-vue", webpackPreload: true */ '@v4/common/components/organisms/ListGroup'
            ),
        }),
        DkPopper: () => ({
            component: import(
                /* webpackChunkName: "DkPopper-vue", webpackPreload: true */ '@v4/common/components/molecules/DkPopper.vue'
            ),
        }),
        InView: () => ({
            component: import(/* webpackChunkName: "InView-vue" */ '@v4/common/components/atoms/InView'),
        }),
    },
    mixins: [dkModalAware, modalCarConfigurator, modalWizardCarConfigurator],
    computed: {
        pricingsPollingUrl() {
            const { makeUrlCode, submodelCommercialUrlCode } = this.fetchedData;

            if (!makeUrlCode || !submodelCommercialUrlCode) {
                return '';
            }

            return stringifyUrl({
                url: `${baseUrl}/${makeUrlCode}/${submodelCommercialUrlCode}`,
                // eslint-disable-next-line camelcase
                query: { ...getQueryParams(), offer_vdp: 1 },
            });
        },
    },
    created() {
        this.fetchSubmodelTags();
    },
    mounted() {
        import(
            /* webpackChunkName: "DkReadMore-vue", webpackPreload: true */ '@v4/common/components/atoms/DkReadMore'
        ).then(({ default: DkReadMore }) => DkReadMore().init());

        const shouldShowLeadForm = getQueryParams().show_lead_form;
        if (shouldShowLeadForm) {
            this.showLeadFormModal();
        }
    },
    methods: {
        async fetchSubmodelTags() {
            const { makeUrlCode, submodelCommercialUrlCode } = this.fetchedData;

            if (!makeUrlCode || !submodelCommercialUrlCode) {
                return;
            }

            this.isBusy = true;

            try {
                const data = await fetchBadges(makeUrlCode, submodelCommercialUrlCode);

                const { categoryD } = data.data;
                this.badges = categoryD ? categoryD.items : [];
                this.isBusy = false;
            } catch (error) {
                this.isBusy = false;
                this.badges = [];
            }
        },
        handleSeeAllOffersTracking() {
            this.pushGaEvent('vehicle detail page', 'click on link "See all offers"', 'click on link "See all offers"');
        },
        handlePriceBoxTracking(boxIndex) {
            this.pushGaEvent('vehicle detail page', 'price box click', `click on ${boxIndex + 1} price box`);
        },
        handlePromoLabelTracking(pricingType = {}) {
            const { text = '', slug = '' } = pricingType;

            this.pushGaEvent('vehicle detail page', 'price box click', `click on ${slug} (${text}) price box`);
        },
        onCarConfiguratorClick() {
            this.openCarConfiguratorModal(this.carConfiguratorOptions, this.setCarConfigurationOption);
        },
        showWizardCarConfigurator() {
            const { makeUrlCode, submodelCommercialUrlCode, formId, formData } = this.fetchedData;

            this.openWizardCarConfiguratorModal({
                make: makeUrlCode,
                model: submodelCommercialUrlCode,
                leadFormWrapper: { formId, formData },
            });
        },
        setCarConfigurationOption(options) {
            this.carConfiguratorOptions = options;
        },
        showLeadFormModal() {
            const { formId, formData } = this.fetchedData;
            if (!formId || !formData) {
                return;
            }

            return import(
                /* webpackChunkName: "SimpleLeadFormModal-vue" */ '@v4/common/components/organisms/SimpleLeadFormModal'
            ).then(
                async ({ default: SimpleLeadFormModal }) =>
                    await this.showModal(
                        SimpleLeadFormModal,
                        {
                            formId,
                            formData,
                            title: this.$t('multi-section-submodel.sidebar.title'),
                            subtitle: this.$t('multi-section-submodel.sidebar.subtitle'),
                        },
                        {
                            name: 'simple-lead-form-modal',
                            height: 'auto',
                            classes: 'modal--fullscreen_medium',
                            width: 680,
                            scrollable: true,
                        }
                    )
            );
        },
    },
});
